import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Link from '@/components/Link';
import { formatNumber } from '@/utils/format';

import ReceiptModal from '../../../purchaseHistoryPage/Page/ReceiptModal';

const Row = ({
  reconciliatioBonusCost,
  reconciliationFiscalId,
  storeName,
  reconciliationId,
}) => {
  const [isReceiptDialogOpen, setIsReceiptDialogOpen] = useState(false);

  const handleReceiptModal = () => {
    setIsReceiptDialogOpen(!isReceiptDialogOpen);
  };

  const preventDefault = event => {
    event.preventDefault();
    handleReceiptModal();
  };

  return (
    <>
      <TableRow>
        <TableCell>{storeName}</TableCell>
        <TableCell>
          <Link to="#" onClick={preventDefault}>
            {reconciliationFiscalId}
          </Link>
        </TableCell>
        <TableCell align="right">
          {formatNumber(reconciliatioBonusCost)}
        </TableCell>
      </TableRow>
      {isReceiptDialogOpen && (
        <ReceiptModal
          uuid={reconciliationFiscalId}
          receipt={reconciliationId}
          isOpen={isReceiptDialogOpen}
          onClose={handleReceiptModal}
        />
      )}
    </>
  );
};

Row.propTypes = {
  reconciliatioBonusCost: PropTypes.number.isRequired,
  reconciliationFiscalId: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  reconciliationId: PropTypes.number.isRequired,
};

export default Row;
